exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#About-body{display:inline-block;padding-bottom:60px}#About-body .About-title{text-align:left;width:554px;margin-top:60px;margin-bottom:28px}#About-body .About-title img{display:inline-block;margin-top:8px;vertical-align:middle}#About-body .About-title h1{font-size:30px;margin-left:10px;color:#282828;vertical-align:middle;display:inline-block}#About-body p{width:554px;text-indent:2em;line-height:36px;font-size:18px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-304c9ecc","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/About.vue
// module id = 140
// module chunks = 0